module.exports = __webpack_public_path__ + "static/media/camera_onvif.3525199c.svg";